"use strict";
// Copyright © Veeam Software Group GmbH.
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewRequestTerminatedError = exports.NewRequestAbortError = void 0;
// Workaround issue in Typescript compiler
// https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
class NewRequestAbortError extends Error {
    constructor(errorMessage = 'An abort occurred.') {
        super(errorMessage);
    }
}
exports.NewRequestAbortError = NewRequestAbortError;
class NewRequestTerminatedError extends Error {
    constructor(errorMessage = 'An request is terminated.') {
        super(errorMessage);
    }
}
exports.NewRequestTerminatedError = NewRequestTerminatedError;
//# sourceMappingURL=Errors.js.map